import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton } from '../ui/skeleton'
import AuthenticatedAppShell from './AuthenticatedAppShell'

export const AppRailFallback = () => (
  <div className="h-full w-20 border-r border-border bg-background">
    <div className="flex h-full flex-col items-center gap-6 py-4">
      <Skeleton className="h-10 w-10 rounded-2xl" />
      {Array.from({ length: 8 }).map((_, index) => (
        <Skeleton key={index} className="h-7 w-7 rounded-lg" />
      ))}
      <div className="mt-auto flex flex-col items-center gap-6 pb-4">
        <Skeleton className="h-7 w-7 rounded-lg" />
        <Skeleton className="h-7 w-7 rounded-lg" />
        <Skeleton className="h-7 w-7 rounded-lg" />
      </div>
    </div>
  </div>
)

const AuthenticatedAppFallback = ({
  children = <div className="h-full bg-background" />,
  hideNavigationOnMobile = false,
}) => (
  <div className="h-screen bg-background">
    <AuthenticatedAppShell
      hideNavigationOnMobile={hideNavigationOnMobile}
      navigation={<AppRailFallback />}
    >
      {children}
    </AuthenticatedAppShell>
  </div>
)

AuthenticatedAppFallback.propTypes = {
  children: PropTypes.node,
  hideNavigationOnMobile: PropTypes.bool,
}

export default AuthenticatedAppFallback
